import { css } from '@emotion/react';

export default css({
    overflow: 'hidden',
    display: 'flex',
    flex: 'none',
    justifyContent: 'center',
    alignItems: 'center',
});
